export default __webpack_public_path__ + "static/media/golpista_amoroso.d63454a0.jpg";